import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./customlightbox.css"; // custom styles

interface Slide {
  src: string; // URL of the image or video
  alt: string; // Alt text for images
  key: number; // Unique key for each slide
  type: "image" | "video"; // Type to differentiate between image and video
}

interface CustomLightboxProps {
  open: boolean;
  close: () => void;
  slides: Slide[];
}

const CustomLightbox: React.FC<CustomLightboxProps> = ({
  open,
  close,
  slides,
}) => {
  return (
    <Lightbox
      open={open}
      close={close}
      slides={slides.map((slide) => ({ src: slide.src }))}
      render={{
        buttonPrev: slides.length > 1 ? undefined : () => null, // Hide prev button for single slide
        buttonNext: slides.length > 1 ? undefined : () => null, // Hide next button for single slide
        slide: ({ slide }: { slide: { src: string } }) => {
          const currentSlide = slides.find((s) => s.src === slide.src);

          if (!currentSlide) return null;

          return currentSlide.type === "video" ? (
            <iframe
              className="youtube-embed"
              width="800px"
              height="500px"
              src={currentSlide.src}
              title="YouTube video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                width: "80%",
                height: "auto",
                aspectRatio: "16 / 9",
                display: "block",
                margin: "0 auto",
              }}
            ></iframe>
          ) : (
            <img
              src={currentSlide.src}
              alt={currentSlide.alt}
              style={{ maxWidth: "100%", height: "auto" }}
            />
          );
        },
      }}
    />
  );
};

export default CustomLightbox;
